export const isEmptyImageId = (imageId?: string): boolean =>
  !imageId || imageId === "0" || imageId === "-1";

export const preloadImage = (src: string) => {
  const img = new Image();
  img.src = src;
};
